import React from 'react';
import UploadIcon from '@atlaskit/icon/core/migration/cloud-arrow-up--upload';
import { fg } from '@atlassian/jira-feature-gating';
import { useIntl } from '@atlassian/jira-intl';
import { MenuItem } from '@atlassian/jira-navigation-apps-sidebar-common/src/common/ui/menu-item/main.tsx';
import { useRouteByName } from '@atlassian/jira-platform-router-utils/src/index.tsx';
import messages from './messages.tsx';

type Props = {
	projectKey: string;
	testId: string;
};

export const DeploymentsMenuItem = ({ projectKey, testId }: Props) => {
	const { formatMessage } = useIntl();
	const deploymentsRoute = useRouteByName('software-deployments-classic');

	// The route definition will be null when this component is rendered outside
	// of the SPA (e.g. the settings page in Classic projects)
	const menuItemProps =
		deploymentsRoute !== null
			? {
					to: deploymentsRoute,
					params: { projectKey },
				}
			: {
					href: `/jira/software/c/projects/${projectKey}/deployments`,
				};
	const iconLabel = formatMessage(
		fg('jira-issue-terminology-refresh-m3')
			? messages.deploymentsIconLabelIssueTermRefresh
			: messages.deploymentsIconLabel,
	);
	const accessibleIconLabel = fg('jfp-a11y-team_old-nav_deployment-icon-readability')
		? ''
		: iconLabel;

	return (
		<MenuItem
			{...menuItemProps}
			analytics={{
				itemId: 'deployments',
			}}
			selectedOn={['software-deployments-classic']}
			iconBefore={<UploadIcon spacing="spacious" label={accessibleIconLabel} />}
			testId={testId}
		>
			{formatMessage(messages.deploymentsItem)}
		</MenuItem>
	);
};
